// extracted by mini-css-extract-plugin
export default {"budgetCap":"O9XiE7vhC49ciUKslJvY","exclamationIcon":"tXD3OxcVRhe7wa8RdrBF","budgetCapTitle":"dmo6xGspUFm9Q1NSMaiV"};